import { FieldPath, FieldValues } from "react-hook-form";
import getBasicMetadata, { BasicMetadata } from "./getBasicMetadata";

export interface TextMetadata<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> extends BasicMetadata<TFieldValues, TName> {
  maxLength: number;
  minLength?: number;
  trimmedString?: boolean;
  transformEmptyStringToNull?: boolean;
  noWhitespacesOnly?: boolean;
  email?: "single" | "multiple";
  pattern: string;
}

export default function getTextMetadata<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(
  name: TName,
  metadata: { [key: string]: any }
): TextMetadata<TFieldValues, TName> {
  // below we temporaily force props without maxLength
  let props: TextMetadata<TFieldValues, TName> = getBasicMetadata(
    name,
    metadata
  ) as TextMetadata<TFieldValues, TName>;

  props.maxLength = metadata.maxLength;
  props.minLength = metadata.minLength;
  props.trimmedString = metadata.trimmed;
  props.transformEmptyStringToNull = metadata.noEmptyOrWhitespaceString;
  props.noWhitespacesOnly = metadata.noEmptyOrWhitespaceString;
  props.email = metadata.eMail;
  props.pattern = metadata.pattern;

  return props as TextMetadata<TFieldValues, TName>;
}
